import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "text-[10px] text-white font-medium mb-2 text-center" }
const _hoisted_4 = { class: "flex justify-center items-center gap-1.5 w-full mb-2" }
const _hoisted_5 = { class: "text-[14px] text-white font-medium select-all" }
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 0,
  class: "size-5 text-gray-100",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = {
  key: 1,
  class: "size-4 text-green-300",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
}
const _hoisted_9 = { class: "text-[13px] text-white text-center mb-3 bg-black/70 px-2 py-0.5 rounded-lg" }
const _hoisted_10 = {
  key: 1,
  class: "text-gray-50 text-center mb-3",
  "aria-live": "polite"
}
const _hoisted_11 = { class: "text-[14px] font-semibold" }
const _hoisted_12 = { class: "text-[12px]" }
const _hoisted_13 = {
  key: 2,
  class: "text-red-200 text-[14px] font-semibold text-center mb-3"
}

export function render(_ctx, _cache) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    class: "flex justify-center items-center w-full bg-[#040202bd]!",
    pt: { root: _ctx.getBankBgClass(_ctx.bankKey), body: 'p-0!' }
  }, {
    content: _withCtx(() => [
      _createCommentVNode(" Loading "),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
            key: 0,
            style: {"width":"50px","height":"50px"},
            strokeWidth: "4",
            fill: "transparent",
            animationDuration: ".5s",
            "aria-label": "กำลังโหลดข้อมูลบัญชี"
          }))
        : (!_ctx.isActive)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Inactive "),
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-red-500 text-sm font-semibold" }, " กรุณาใช้ช่องทางอื่น ", -1 /* HOISTED */))
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" Content "),
              _createElementVNode("div", _hoisted_1, [
                (_ctx.getBankImage(_ctx.bankKey))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.getBankImage(_ctx.bankKey),
                      alt: _ctx.bank.bankName || 'bank-logo',
                      class: "size-14 mx-auto my-3",
                      onError: _cache[0] || (_cache[0] = $event => ($event.target.style.display = 'none'))
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.bank.bankName === 'SCB_ANY' ? 'SCB' : _ctx.bank.bankName || 'ไม่พบข้อมูล'), 1 /* TEXT */),
                _createCommentVNode(" เลขบัญชี + copy "),
                _createElementVNode("p", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.bank.bankNumber || 'ไม่พบข้อมูล'), 1 /* TEXT */),
                  (_ctx.isCopyNumber && _ctx.bank.bankNumber)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args))),
                        type: "button",
                        class: "cursor-pointer",
                        title: _ctx.copied ? 'คัดลอกแล้ว' : 'คัดลอกเลขบัญชี',
                        "aria-label": "คัดลอกเลขบัญชี"
                      }, [
                        (!_ctx.copied)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _cache[3] || (_cache[3] = [
                              _createElementVNode("path", {
                                stroke: "currentColor",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M14 4v3a1 1 0 0 1-1 1h-3m4 10v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2m11-3v10a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V7.87a1 1 0 0 1 .24-.65l2.46-2.87a1 1 0 0 1 .76-.35H18a1 1 0 0 1 1 1Z"
                              }, null, -1 /* HOISTED */)
                            ])))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_8, _cache[4] || (_cache[4] = [
                              _createElementVNode("path", {
                                d: "M20 6L9 17l-5-5",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, null, -1 /* HOISTED */)
                            ])))
                      ], 8 /* PROPS */, _hoisted_6))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" ชื่อบัญชี "),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.bank.fullName || '—'), 1 /* TEXT */),
                _createCommentVNode(" จำนวนเงิน & countdown "),
                (_ctx.remaining > 0 && _ctx.showAmount > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, "ฝาก " + _toDisplayString(_ctx.formatCurrency(_ctx.showAmount)), 1 /* TEXT */),
                      _cache[5] || (_cache[5] = _createTextVNode()),
                      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                      _cache[7] || (_cache[7] = _createTextVNode()),
                      _createElementVNode("span", _hoisted_12, "ภายใน " + _toDisplayString(_ctx.remaining) + " วินาที", 1 /* TEXT */)
                    ]))
                  : (_ctx.expired && _ctx.showAmount > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, " หมดเวลาแล้ว กรุณาสร้างรายการใหม่ "))
                    : _createCommentVNode("v-if", true)
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["pt"]))
}